import classNames from 'classnames'
import { IconFa } from '../icon-fa'
import { PlainButton } from '../plain-button'
import styles from './Chip.module.css'

export type ChipVariant = 'default' | 'include' | 'exclude'

export type ChipSize = 'small' | 'large'

interface ChipProps extends React.HTMLAttributes<HTMLDivElement> {
  buttonTitle?: string
  onClick?: () => void
  variant?: ChipVariant
  border?: boolean
  size?: ChipSize
}

export const Chip = ({
  children,
  buttonTitle,
  onClick,
  className,
  border,
  variant = 'default',
  size = 'large',
  ...props
}: ChipProps) => (
  <div
    className={classNames(styles.chip, styles[variant], styles[size], border && styles.border, className)}
    {...props}
  >
    <div className={classNames(styles.content, onClick && styles.withButton)}>{children}</div>
    {onClick && (
      <PlainButton
        onClick={onClick}
        type="button"
        aria-label={buttonTitle}
        className={classNames(styles.button, styles[variant])}
      >
        <IconFa icon={['far', 'times']} title={buttonTitle} />
      </PlainButton>
    )}
  </div>
)
